export default "__VITE_ASSET__d5e0174f__"